import React, {useState} from 'react'

import Searcher from './Searcher/Searcher.js'
import RoomsAvailable from './RoomsAvailable/RoomsAvailable.js'

import reqwest from 'reqwest'

const dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
var timezoneJS = require('dayjs/plugin/timezone')

export const urlJoan = 'https://portal.getjoan.com/api/'
export const urlBack = process.env.REACT_APP_URL_BACK || 'https://api-rooms.cem-cat.org/'
export const timezone = 'Europe/Madrid'
export const versionApi = 'v1.0/'

dayjs.extend(utc)
dayjs.extend(timezoneJS)


const BookingRoom = () => {
	const [searching, setSearching] = useState(true) 
	const [values, setValues] = useState({date: null, time: [], description: null, email: null, occupants: 1})
	const [roomsInfo, setRoomsInfo] = useState([])
	
	const getAvailableRooms = async (values) => {
		const d2 = dayjs.tz(dayjs(values.date).format('YYYY-MM-DD') + 'T' + dayjs(values.time[0]).format('HH:mm'), 'Europe/Madrid')
		const d3 = dayjs.tz(dayjs(values.date).format('YYYY-MM-DD') + 'T' + dayjs(values.time[1]).format('HH:mm'), 'Europe/Madrid')
		const eventStart = d2.format()
		const eventFinish = d3.format()
		
		await reqwest({
		  url: urlBack,
		  method: 'get',
		  data: {
			timeMin: eventStart,
			timeMax: eventFinish,
			occupants: values.occupants
		  },
		  type: 'json',
		  crossOrigin: true,
		}).then(data => {
			setRoomsInfo(data.roomsAvailable ? data.roomsAvailable : [] )
			setValues(values)
			setSearching(false)
		})
	}
	
	return (
		<>
		{
			searching ?
				<Searcher getAvailableRooms={getAvailableRooms} values={values} />
			:
				<RoomsAvailable values={values} setSearching={setSearching} roomsInfo={roomsInfo} />			
		}
		</>
	)
}

export const generateToken = async (urlJoan) => {
	let token = null
	await reqwest({
	  url: urlJoan + 'token/',
	  method: 'post',
	  data: {
		grant_type: 'client_credentials',
		client_id: 'TVHRAa71KbualGX1YBnHy1GkPob7uWZCxEejEvYq',
		client_secret:
		  '7wrUD2aRXpdPlOUILcXc3YwUb4AtltGboTH54aSeWpf8URVXU6gom2Fer0Rgo3rSbveXDd7fB4jOfVdKZ6uvBi0y3pJ0uzH5QzgnGgsZvstW6pRIBtElS7LGVXwVEwpH',
	  },
	  type: 'json',
	  crossOrigin: true,
	}).then(data => {
	  token = data.access_token
	})
	return token
  }


export default BookingRoom